import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { ClienteListItem } from '../../../types/cliente';
import { ClienteKycBadge } from './cliente-kyc-badge';
import { formatDocumento, formatTelefone } from './format';

interface Props {
  items: ClienteListItem[];
  onOpenDetail: (id: string) => void;
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.li`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

const Card = styled.button`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 16px;
  background: transparent;
  border: none;
  border-radius: inherit;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / -1;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }

  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 4px;
`;

const fullName = (item: ClienteListItem): string =>
  `${item.nome ?? ''} ${item.sobrenome ?? ''}`.trim() || '—';

export const ClientesCards = ({ items, onOpenDetail }: Props) => (
  <List>
    {items.map((cliente) => (
      <Item key={cliente.id}>
        <Card
          onClick={() => onOpenDetail(cliente.id)}
          data-testid={`cliente-card-${cliente.id}`}
        >
          <Top>
            <Info>
              <strong>{fullName(cliente)}</strong>
              <small>{cliente.email}</small>
            </Info>
            <ClienteKycBadge
              status={cliente.statusKyc}
              description={cliente.statusKycDescricao}
            />
          </Top>
          <Info>
            <span>{formatDocumento(cliente.documento)}</span>
            <small>{formatTelefone(cliente.telefone)}</small>
          </Info>
          <Meta>
            <span>{cliente.tipoPessoa ?? '—'}</span>
            <ChevronRight size={16} />
          </Meta>
        </Card>
      </Item>
    ))}
  </List>
);
